import './Header.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"

const Header = observer(
  class Header extends Component {
    state={
			username : 'baba'
    }

    constructor(props) {
      super(props);
      if (props.username)
        this.state.username = props.username;
    }

		closeart = () => {
			if(window.confirm('Möchten Sie den Artikel abschließen?'))
				this.props.flow.editDistproject(this.props.articleId,{"workstatus":'geschlossen'}).then(res=>this.postcloseart(res));
		}
		
		postcloseart = () => {
			this.props.cbartsearchclicked();
		}

    render() {
			let artclosknob = null;
			if(this.props.articleId < -90) artclosknob = <button className="red knob" onClick={ this.closeart }>Schließen</button>;
			return  <div className="headerdiv">
								<img src="vifogralogo.png" alt="" className="logopic" />
								<button className="black knob" onClick={ this.props.cbartsearchclicked }>Home</button>
								<button className="red knob" onClick={ this.props.cbnewartclicked }>Neuer Artikel</button>
									{artclosknob}

								<div className="newsdesklabel">NEWSDESK: +49 8252 90 39 570</div>
								{this.props.headerrmess.length > 0 &&(<div className="headerrmess">{this.props.headerrmess}</div>)}
								<div onClick={ this.props.cblogoutclicked } className="userdiv">LOGOUT</div>
							</div>
    }
		
		
		
		
  }
)


export default Flow.injectFlow(Header);